import { updateNotification } from 'api/notifications.api';
import { $list } from 'signals/global.signals';
import displayError from 'utils/displayError';

export const handleClickDismissInvestorNotification = async (id) => {
  const data = $list.value?.data?.filter(n => n.id !== id);
  $list.update({ data });

  try {
    await updateNotification(id, {
      isDismissed: true,
    });
  } catch (e) {
    displayError({
      message: 'Failed to dismiss notification. Please try again.',
      title: 'Notification Error',
    });
  }
};
